module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"ui":{"components":{"social_events":{"empty_state":{"to_investment_profile":"Adjust investment profile","to_notification_settings":"Notification settings"}}}}}}')
  delete Component.options._Ctor
}
